import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InsuranceTile from 'src/components/BuyPolicy/insuranceScreens/health/InsuranceTile'
import LotusImg from 'src/assets/Buy_Policy_Images/lotus.svg'

export const useStyles = makeStyles({
  premiumContainerMain: {
    display: 'flex',
    flexDirection: 'column',
    margin: '20px 0',
  },
  premiumContainer: {
    border: '1px solid #ED99B9',
    borderRadius: '5px 5px 0px 0px',
    background: 'linear-gradient(180deg, #ED99B9 4.08%, #FFFFFF 102.47%)',
    width: 'fit-content',
    marginLeft: '4%',
  },
  insuranceTileContainer: {
    width: '100%',
    position: 'absolute',
    opacity: 5,
    background: '#FFFF',
    zIndex: 1,
  },
  protectionContainer: {
    position: 'relative',
  },
  premiumContainerText: {
    color: '#651E34',
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '13px',
    letterSpacing: '0.02em',
    padding: 5,
  },
  premiumRecommendedContainerMain: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 14,
    position: 'relative',
    left: '-25px',
    top: '30px',
  },
  premiumRecommendedContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    borderRadius: '10px 10px 10px 10px',
    background: 'linear-gradient(277.71deg, #73CFEE 3.07%, #EF669B 99.03%)',
    position: 'relative',
  },
  premiumRecommendedContainerSub: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '5px 0',
    margin: '0 50px',
    width: 'fit-content',
  },
  premiumRecommendedTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    height: '30vh',
    position: 'relative',
  },
  premiumRecommendedTextOne: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '12.89px',
    letterSpacing: '0.02em',
    color: '#FFFFFF',
  },
  premiumRecommendedTextTwo: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '12.89px',
    letterSpacing: '0.02em',
    color: '#651E34',
  },
  premiumRecommendedTextThree: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '12.89px',
    letterSpacing: '0em',
    color: '#818080',
  },
  textVertical: {
    color: '#FFFFFF',
    width: '20px',
    writingMode: 'vertical-rl',
    fontFamily: 'Roboto',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '12px',
    letterSpacing: '0em',
    marginBottom: '45px',
    paddingTop: '15px',
  },
})

const InsuranceTilePremium = ({ insuranceDetails }) => {
  const classes = useStyles()

  return (
    <div>
      <div className={classes.premiumContainerMain}>
        <div className={classes.premiumContainer}>
          <span className={classes.premiumContainerText}>PremiumShield</span>
        </div>
        <div className={classes.protectionContainer}>
          <div className={classes.insuranceTileContainer}>
            <InsuranceTile insuranceDetails={insuranceDetails} />
          </div>
          <div className={classes.premiumRecommendedContainerMain}>
            <div className={classes.premiumRecommendedContainer}>
              <div className={classes.textVertical}>WE MADE FOR YOU</div>
              <div className={classes.premiumRecommendedContainerSub}>
                <div>
                  <img src={LotusImg} alt='premiumShield-img'></img>
                </div>
                <div className={classes.premiumRecommendedTextOne}>
                  Unmatched Protection for Your Peace of Mind
                </div>
              </div>
            </div>
            {/* <div className={classes.premiumRecommendedTextContainer}>
              <div className={classes.premiumRecommendedTextThree}>* 20% after the age of 61</div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InsuranceTilePremium
